import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

export const CTASection = () => {
    return (
        <section className="relative max-w-6xl mx-auto rounded-3xl overflow-hidden my-8">
            {/* Vivid gradient background with animation */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600 via-sky-600 to-cyan-600 opacity-90 animate-gradient-x"></div>
            
            {/* Decorative pattern */}
            <div className="absolute inset-0" style={{ 
                backgroundImage: 'radial-gradient(circle at 20px 20px, rgba(255, 255, 255, 0.15) 2px, transparent 0)',
                backgroundSize: '40px 40px'
            }}></div>
            
            {/* Decorative elements */}
            <div className="absolute -top-16 -left-16 w-32 h-32 rounded-full bg-pink-500/30 blur-3xl"></div>
            <div className="absolute -bottom-8 -right-8 w-24 h-24 rounded-full bg-blue-500/30 blur-2xl"></div>
            
            <div className="relative z-10 py-20 px-8 text-center">
                <Badge className="bg-white/30 text-white hover:bg-white/40 mb-8 backdrop-blur-sm px-5 py-2 border-white/20">
                    Limited Time Offer
                </Badge>
                <h2 className="text-3xl md:text-5xl font-bold mb-8 text-white leading-tight max-w-3xl mx-auto drop-shadow-md">
                    Get 15% Off Your First Berry Sensor Purchase
                </h2>
                <p className="text-white text-lg max-w-2xl mx-auto mb-10">
                    Join thousands of parents who trust BerryBabies to keep their little ones comfortable and healthy.
                </p>
                <Button size="lg" className="bg-white text-berry-purple hover:bg-white/90 hover:text-berry-purple/90 btn-baby text-lg px-10 py-6 shadow-xl transition-all duration-300 transform hover:scale-105">
                    Shop Now and Save
                </Button>
            </div>
        </section>
    );
};